import { Input } from '@alifd/next';
import wrapper from './next-wrapper';
const FormInput = wrapper(Input, 'CbayelFormInput');
export const CbayelInput = Input;
export default FormInput;
